<admin-page-second *ngIf="show()" [title]="'pages.screening.title' | translate">

  <admin-section-standard [title]="'pages.screening.fields' | translate" *ngIf="!showResults()">
    <admin-lookup-common-tabs>
      <admin-lookup-common-form/>
    </admin-lookup-common-tabs>
    <div class="row">
      <div class="col-12 text-end">
        <button (click)="lookup()" class="btn btn-action-2 rounded-1" type="submit">{{ 'common.buttons.lookup' | translate }}</button>
      </div>
    </div>
  </admin-section-standard>

  <admin-section-standard [title]="'Scoring Result'" *ngIf="showResults()">
    <admin-channel-view-desc [config]="definition.config"/>
    <admin-panel-empty>
      <admin-accordion-nice [items]="results">
        <ng-template #first let-item let-index="index" let-refid="refid">
          <admin-lookup-common-rules [factor]="item" class="row"/>
        </ng-template>
        <ng-template #second let-item>
          <admin-panel-inner>
            <admin-lookup-common-factor [factor]="item"/>
          </admin-panel-inner>
        </ng-template>
      </admin-accordion-nice>
    </admin-panel-empty>

    <div class="row pt-5">
      <div class="col-12 text-end">
        <button (click)="reset()" class="btn btn-outline-third rounded-1 me-2" type="submit">{{'common.buttons.reset' | translate}}</button>
        <button (click)="refine()" class="btn btn-outline-first rounded-1 me-2" type="submit">{{'common.buttons.refine' | translate}}</button>
        <button (click)="report()" class="btn btn-second rounded-1" type="submit">{{'common.buttons.report' | translate}}</button>
      </div>
    </div>
  </admin-section-standard>

</admin-page-second>
